import { iconSizes } from '@/theme/tokens';
import { Stack } from '@/ui/layout/Stack';
import { Box, CircularProgress, Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type StatusPresentationLoadingStateProps = {
  message: string;
};

export const StatusPresentationLoadingState = ({
  message,
}: StatusPresentationLoadingStateProps): ReactElement => (
  <Box
    sx={{
      minHeight: '45vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack gap="md" align="center">
      <Text role="body" color="textSecondary" align="center">
        {message}
      </Text>
      <CircularProgress size={iconSizes.lg} />
    </Stack>
  </Box>
);
